import React from 'react';
import MUITableHead from '@material-ui/core/TableHead';

import {ColumnType, Sort} from '../tableTypes';
import TableHeaderContainer from './TableHeaderContainer';

interface TableHeaderProps {
    columns: ColumnType[],
    setSort?: (sort: Sort) => void,
    sort?: Sort,
}

export default function TableHeader({columns, setSort, sort}: TableHeaderProps) {
    return (
        <MUITableHead>
            <TableHeaderContainer
                columns={columns}
                setSort={setSort}
                sort={sort}
            />
        </MUITableHead>
    );
}
